import React from 'react';
import PropTypes from 'prop-types';
import { ArrowForwardIos } from '@mui/icons-material';
import styles from 'ripple/Components/GridTileScroller/NextButton.scss';

const NextButton = ({ children, hover, ...props }) => {
  return (
    <ArrowForwardIos classes={{ root: styles.root }} {...props}>
      {children}
    </ArrowForwardIos>
  );
};

NextButton.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  hover: PropTypes.bool,
};

export default NextButton;
